import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SnackbarService } from 'src/app/layout/snackbars/snackbar.service';
import { SpinnerService } from 'src/app/layout/spinner.service';
import { Airline, Contact, Status } from 'src/app/shared/shared.models';
import { AirlineSettingsService } from '../airline-settings.service';
import { MatPaginator } from '@angular/material/paginator';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatTableDataSource, MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow } from '@angular/material/table';
import { DialogStructureComponent } from '../../../layout/dialog-structure/dialog-structure.component';
import { MatFormField, MatLabel, MatInput, MatError } from '@angular/material/input';
import { MatSelect, MatOption } from '@angular/material/select';
import { MatButton, MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';
import { MatDivider } from '@angular/material/divider';

@Component({
    selector: 'app-airline-settings-dialog',
    templateUrl: './airline-settings-dialog.component.html',
    styleUrls: ['./airline-settings-dialog.component.scss'],
    imports: [DialogStructureComponent, FormsModule, ReactiveFormsModule, MatFormField, MatLabel, MatInput, MatError, MatSelect, MatOption, MatButton, MatIcon, MatTooltip, MatDivider, MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatIconButton, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow, MatPaginator]
})
export class AirlineSettingsDialogComponent implements OnInit {
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatPaginator) airlinePaginator: MatPaginator;
  data: any;

  constructor(
    private airlineSettingsService: AirlineSettingsService,
    private snackbarService: SnackbarService,
    private spinnerService: SpinnerService,
    private dialogRef: MatDialogRef<AirlineSettingsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) data
  ) {
    this.data = data;
  }
  airlineForm: UntypedFormGroup;
  contactsForm: UntypedFormGroup;

  contactsTableSource = new MatTableDataSource();
  contactsdata: Contact[] = [];
  displayedContactColumns: string[] = [
    'contactName',
    'contactMail',
    'contactPhone',
    'actions',
  ];
  airline: Airline;

  isImporting = false;
  @ViewChild('file') file;

  status: Status[] = [
    { value: 0, viewValue: 'inactive' },
    { value: 1, viewValue: 'active' },
  ];

  ngOnInit(): void {
    this.airlineForm = new UntypedFormGroup({
      status: new UntypedFormControl(null, [Validators.required]),
      airlineName: new UntypedFormControl(null, [Validators.required]),
      abbreviation: new UntypedFormControl(null, [Validators.required]),
      iata: new UntypedFormControl('', [
        Validators.maxLength(3),
        Validators.minLength(3),
      ]),
    });
    if (this.data) {
      this.airline = this.data;
      this.setFormValues(this.data);
      this.getContacts();
    }

    this.contactsForm = new UntypedFormGroup({
      contactName: new UntypedFormControl(null, Validators.required),
      contactMail: new UntypedFormControl(null, [
        Validators.required,
        Validators.email,
      ]),
      phoneNumber: new UntypedFormControl(null, Validators.required),
    });
  }

  submitEmitter(): void {
    // when airline existing -> update
    if (this.airline) {
      this.airline.contacts = this.contactsdata;
      this.airline = Object.assign(this.airline, this.airlineForm.value);
    } else {
      this.airline = this.airlineForm.value;
      this.airline.contacts = this.contactsdata;
      // add to table
    }

    this.dialogRef.close(this.airline);
  }

  setFormValues(airline: Airline): void {
    this.airlineForm.patchValue(airline);
  }

  importERateSheet(): void {
    this.file.nativeElement.value = null; // fix for uploading same file twice
    this.file.nativeElement.click();
  }

  import(): void {
    this.isImporting = true;
    this.spinnerService.startSpinner();
    this.airlineSettingsService
      .import(this.file.nativeElement.files[0], this.airline.id)
      .subscribe(
        (data) => {
          this.spinnerService.stopSpinner();
          this.airline = data;
          this.isImporting = false;
          this.snackbarService.openSuccess();
        },
        (error) => {
          this.spinnerService.stopSpinner();
          this.snackbarService.openError(error.status);
          this.isImporting = false;
        }
      );
  }

  close(): void {
    this.dialogRef.close();
  }

  // --- CONTACTS ---
  addContact(): void {
    let c: Contact = {
      contactMail: this.contactsForm.controls.contactMail.value,
      contactPerson: this.contactsForm.controls.contactName.value,
      phoneNumber: this.contactsForm.controls.phoneNumber.value,
    };


    c.id = Math.floor(Math.random() * (500 - 0 + 1)) + 0;
    this.contactsdata.push(c);

    this.contactsTableSource = new MatTableDataSource(this.contactsdata);
    this.contactsTableSource.paginator = this.paginator;
  }

  getContacts(): void {
    if (this.airline.contacts == null) {
      this.airline.contacts = [];
    }
    this.contactsdata = this.airline.contacts;
    this.contactsTableSource = new MatTableDataSource(this.contactsdata);
  }

  deleteContact(index: number): void {
    this.contactsdata.splice(index, 1);
    this.contactsTableSource = new MatTableDataSource(this.contactsdata);
    this.contactsTableSource.paginator = this.airlinePaginator;
  }

  // check if the contacts table is empty
  contactsValiadtion(): boolean {
    if (this.contactsdata.length === 0) {
      return false;
    }
    return true;
  }
}

